import { useEffect, useRef } from "react";
import { aboutContent } from "@/mocks/homepage";

export default function About() {
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );

    const stats = statsRef.current?.children;
    if (stats) {
      Array.from(stats).forEach((stat, index) => {
        stat.classList.add("opacity-0", "translate-y-8", "transition-all", "duration-700");
        (stat as HTMLElement).style.transitionDelay = `${index * 100}ms`;
        observer.observe(stat);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-20 md:py-28 bg-dark-50">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-6">
            {aboutContent.label}
          </span>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-16">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight mb-6">
                {aboutContent.title}
              </h2>
            </div>
            <div>
              <p className="text-dark-500 text-base sm:text-lg leading-relaxed">
                {aboutContent.description}
              </p>
            </div>
          </div>

          <div ref={statsRef} className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {aboutContent.stats.map((stat, index) => (
              <div key={index} className="text-left">
                <div className="text-4xl sm:text-5xl font-bold text-brand-600 mb-2">
                  {stat.value}
                </div>
                <div className="text-sm text-dark-400 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}